<ng-container *ngIf="course">
  <ng-container *ngIf="course.type === 'itinerary'; else defaultCourseCard">
    <lms-itinerary-card
      [itinerary]="course"
      [defaultAccessMode]="defaultAccessMode"
      [accessModeInfo]="accessModeInfo"
      [selectable]="selectable"
      [selected]="selected"
      (itinerarySelected)="selectCourse($event)"
      (courseEvent)="emitCourseEvent($event)"
    >
    </lms-itinerary-card>
  </ng-container>
  <ng-template #defaultCourseCard>
    <div class="courses-cards__item" [ngClass]="{ checked: selected }">
      <div *ngIf="selectable" class="courses-cards__selectable">
        <gl-checkbox round [checked]="selected" (onChange)="selectCourse($event.detail.value)"></gl-checkbox>
      </div>
      <div class="courses-cards__image">
        <img onError="this.style.display = 'none';" [src]="imageUrl" />
        <span *ngIf="course.withdrawn" class="courses-cards__status-label courses-cards__withdrawn-label notItinerary">
          <span>{{ 'courses.config.labelCardDraw' | translate }}</span>
        </span>
      </div>
      <div class="courses-cards__data">
        <div class="courses-cards__block">
          <div class="duration">
            {{ course.hours ? course.hours + 'h' : course.minutes ? '' : '0h' }}
            {{ course.minutes ? course.minutes + 'min' : '' }}
          </div>
          <div>{{ cost }}</div>
        </div>
        <div class="courses-cards__title">
          {{ course.title || course.name }}
        </div>
        <div class="courses-cards__topic">
          {{ course.topic }}
        </div>
        <div class="courses-cards__originator" [ngClass]="{ active: course.clientName === 'Gamelearn' }">
          {{ course.clientName }}
        </div>
        <span class="courses-cards__info" *ngIf="defaultAccessMode">{{ accessModeInfo }}</span>
      </div>
      <div class="courses-cards__actions">
        <gl-button
          color-secondary
          text="{{ userRole === 'hr' ? ('actions.seeCourse' | translate) : ('actions.seeOrEdit' | translate) }}"
          (onClick)="showDetail()"
        ></gl-button>
      </div>
    </div>
  </ng-template>
</ng-container>
